import { render } from "./ViewOrders.vue?vue&type=template&id=256d80ed&scoped=true"
import script from "./ViewOrders.vue?vue&type=script&lang=js"
export * from "./ViewOrders.vue?vue&type=script&lang=js"

import "./ViewOrders.vue?vue&type=style&index=0&id=256d80ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256d80ed"]])

export default __exports__